export enum GACHA_PRIZE {
	MAVERICK1 = 'm1',
	MAVERICK2 = 'm2',
	MAVERICK3 = 'm3',
	MAVERICK4 = 'm4',
	MAVERICK5 = 'm5',
}

export type GachaState = {
	nextSpinTimestamp: number
	txCredit: number
	[GACHA_PRIZE.MAVERICK1]: number
	[GACHA_PRIZE.MAVERICK2]: number
	[GACHA_PRIZE.MAVERICK3]: number
	[GACHA_PRIZE.MAVERICK4]: number
	[GACHA_PRIZE.MAVERICK5]: number
}
